(function () {
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function setInvalid(field, bad) {
    if (!field) return;
    field.classList.toggle('is-invalid', bad);
    var input = field.querySelector('.ctrl');
    if (input) input.classList.toggle('is-invalid', bad);
  }
  function initForm(scope) {
    var form = (scope || document).querySelector('#inquiryForm');
    if (!form || form.dataset.csBound) return;
    form.dataset.csBound = '1';
    form.querySelectorAll('.ctrl').forEach(function (c) {
      c.addEventListener('input', function () { var f = c.closest('.field'); if (f) setInvalid(f, false); });
    });
    form.addEventListener('submit', function (e) {
      var ok = true;
      var checks = [['#f-name', function (v) { return v.trim().length > 0; }],
                    ['#f-company', function (v) { return v.trim().length > 0; }],
                    ['#f-email', function (v) { return validEmail(v.trim()); }]];
      checks.forEach(function (p) {
        var el = form.querySelector(p[0]); if (!el) return;
        var bad = !p[1](el.value); setInvalid(el.closest('.field'), bad); if (bad) ok = false;
      });
      if (!ok) { e.preventDefault(); var firstBad = form.querySelector('.field.is-invalid .ctrl'); if (firstBad) firstBad.focus(); }
    });
  }
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.vsl-cs [data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function initNav(scope) {
    var burgers = (scope || document).querySelectorAll('[data-corp-burger]');
    burgers.forEach(function (btn) {
      if (btn.dataset.csBound) return;
      btn.dataset.csBound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) { panel.hidden = false; panel.classList.toggle('is-open', !open); }
      });
      if (panel) {
        panel.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () {
            btn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
          });
        });
      }
    });
  }
  function init(scope) { initForm(scope); initReveal(scope); initNav(scope); }
  if (document.readyState !== 'loading') { init(document); }
  else { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
